import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { z } from 'zod'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const optionalNumber = (min?: number, max?: number) =>
  z.preprocess(
    (val) =>
      val === '' || val === null || val === undefined ? undefined : Number(val),
    z
      .number()
      .min(min ?? -Infinity)
      .max(max ?? Infinity)
      .optional()
  )
